export default __webpack_public_path__ + "static/media/MeebitsDao_Logo_Transparent-v2.6612cbb4.png";